// extracted by mini-css-extract-plugin
export var wrapper = "styles-module--wrapper--3xsvz";
export var element = "styles-module--element--1P4zO";